uniform vec2 uResolution;
uniform float uTime;
uniform sampler2D diffuse1;
uniform float diffuse1Ratio;
varying vec2 vUv;

float inverseLerp(float v, float minValue, float maxValue) {
    return (v - minValue) / (maxValue - minValue);
}

float remap( float v, float inMin, float inMax, float outMin, float outMax ) {
    float t = inverseLerp(v, inMin, inMax);
    return mix(outMin, outMax, t);
}



void main() {
  // vec2 uv = vUv;
  vec2 uv = vUv;
  vec3 color = vec3(uv.x, uv.y, 1.0);
  if(diffuse1Ratio > 1.0)  {
    uv.y = uv.y * diffuse1Ratio;
    uv.y = uv.y - (1.0 * diffuse1Ratio - 1.0) / 2.0;
    } else {
    uv.x = uv.x / diffuse1Ratio;
    uv.x = uv.x - (1.0 / diffuse1Ratio - 1.0) / 2.0;
  }
  // uv.x /= 0.66;
  // uv.x -= 0.25;
  gl_FragColor = vec4(color, 1.0);
  gl_FragColor = texture2D(diffuse1, uv);

  #include <colorspace_fragment>
// #include <tonemapping_fragment>
}